document.addEventListener("alpine:init", () => {
  Alpine.data(
    "Anchorable",
    ({ 
      anchor_options = [], 
      containerRef, 
      container = null,
      index_items = [],
      containerOffset = 0,
    }) => ({
      anchor_options: [],
      container: null,
      focusedRef: undefined,
      index_items,
      containerOffset,
      init() {
        if (container != null) {
          this.container = container;
        } else {
          if (containerRef) {
            this.container = window.document.body.querySelector(containerRef);
          }
        }
        var that = this;
      },
      onGoAnchor(elId) {
        if (elId == this.focusedRef) {
          return;
        }
        if (this.container) {
          var el = this.container.querySelector(elId);
        } else {
          var el = window.document.body.querySelector(elId);
        }

        if (el) {
          var elPoistion = el.getBoundingClientRect().top;
          const indexHeaderPixel = getComputedStyle(this.$root).getPropertyValue('--index-header-height');
          containerOffset = containerOffset + parseInt(indexHeaderPixel);
          if (this.container) {
            var offsetPosition = elPoistion + this.container.scrollTop -containerOffset - 70;
            this.container.scrollTo({
              top: offsetPosition,
              behavior: "smooth",
            });
            this.focusedRef = elId;
            var that = this;
            this.container.addEventListener(
              "scroll",
              (event) => {
                that.focusedRef = null;
              },
              { once: true }
            );
          } else {
            var offsetPosition = elPoistion + window.scrollY - containerOffset - 70;
            window.scrollTo({
              top: offsetPosition,
              behavior: "smooth",
            });
          }
        }
      },
      registerAnchor(elId, name) {
        this.anchor_options = this.anchor_options.concat([
          {
            name: name,
            element_id: elId,
          },
        ]);
      },
    })
  );


  Alpine.data(
    "AnchorList",
    ({ 
      containerRef, 
      container = null,
      index_items = [],
      /*
      @var index_itmes: { name: string; [key:string]: any }[]  
      */
    }) => ({
      anchor_options: [],
      container: null,
      focusedRef: undefined,
      index_items,
      anchor_items: [],
      init() {
        if (container != null) {
          this.container = container;
        } else {
          if (containerRef) {
            this.container = window.document.body.querySelector(containerRef);
          }
        }
        var that = this;
        // group by
        const anchor_items = this.groupByFirstLetter(this.index_items);

        this.anchor_items = Object.entries(anchor_items).map(([key, value]) => ({
          name: key,
          items: value,
        }));
        this.anchor_options = Object.keys(anchor_items).map((key) => ({
          name: key,
        }));
      },
      groupByFirstLetter(data){
        // give a list of items, group them by the first letter of the name
        // if not alphabet, group them by '#'
        var grouped = {};
        data.forEach((item)=>{
          var firstLetter = item.name[0].toUpperCase();
          if(firstLetter.match(/[A-Z]/)){
            if(!grouped[firstLetter]){
              grouped[firstLetter] = [];
            }
            grouped[firstLetter].push(item);
          }else{
            if(!grouped['#']){
              grouped['#'] = [];
            }
            grouped['#'].push(item);
          }
        });
        return grouped;
      },
      onGoAnchor(elId) {
        if (elId == this.focusedRef) {
          return;
        }
        if (this.container) {
          var el = this.container.querySelector(elId);
        } else {
          var el = window.document.body.querySelector(elId);
        }

        if (el) {
          var elPoistion = el.getBoundingClientRect().top;

          if (this.container) {
            var offsetPosition = elPoistion + this.container.scrollTop - 70;
            this.container.scrollTo({
              top: offsetPosition,
              behavior: "smooth",
            });
            this.focusedRef = elId;
            var that = this;
            this.container.addEventListener(
              "scroll",
              (event) => {
                that.focusedRef = null;
              },
              { once: true }
            );
          } else {
            var offsetPosition = elPoistion + window.scrollY - 70;
            window.scrollTo({
              top: offsetPosition,
              behavior: "smooth",
            });
          }
        }
      },
    })
  );
});
